import { useState, useEffect } from 'react';
import { API_ENDPOINTS, fetchFromApi } from '../config/api';

export const useUpcomingEvents = () => {
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const data = await fetchFromApi(API_ENDPOINTS.upcomingEvents, {
          method: 'GET',
          mode: 'cors'
        });
        
        if (!data || data.error) {
          console.error('Error fetching events:', data?.error);
          setUpcomingEvents([]);
          return;
        }

        const currentDate = new Date();
        const oneWeekFromNow = new Date(currentDate.getTime() + 7 * 24 * 60 * 60 * 1000);
        
        // Backend returns only the next event per event_name series
        // Format each event with upcoming_dates array for card compatibility
        const formattedEvents = data.map(event => {
          const isWithinWeek = new Date(event.event_start) <= oneWeekFromNow;
          return {
            ...event,
            upcoming_dates: [event],
            isWithinWeek: isWithinWeek
          };
        });

        setUpcomingEvents(formattedEvents);
        
      } catch (err) {
        console.error('Error in fetchEvents:', err);
        setUpcomingEvents([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  return { upcomingEvents, loading };
};

export default useUpcomingEvents;
